// Default structure for a charge row
export const chargeRowDefault = {
  charge_code: "",
  sac_code: "",
  currency: "",
  rate: "",
  quantity: "",
  taxable_amount: "",
  gst: "",
  gst_amount: "",
  gst_applicable: "Yes",
  applicableContainers: [],
};

// Reusable portal styles for all react-select dropdowns
export const selectPortalStyles = {
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
    fontSize: 14,
    fontWeight: 400,
  }),
  menu: (base) => ({
    ...base,
    minWidth: 180,
    width: "max-content",
  }),
};

export const INITIAL_VENDOR_TEMPLATE = {
  id: "PUR-NEW",
  vendor_name: "",
  vendor_location: "",
  gst_number: "",
  pan_number: "",
  voucher_invoice_number: "",
  vendor_invoice_date: "",
  vb_number: "",
  vendor_job_number: "",
  master_shipper: "",
  master_consignee: "",
  master_bl_number: "",
  vessel_name: "",
  vessel_number: "",
  voyage_number: "",
  estimated_date: "",
  cut_off_date: "",
  items: [
    {
      charge_code: "",
      sac_code: "",
      currency: "INR",
      rate: "",
      quantity: "",
      taxable_amount: "",
      gst_applicable: "Yes",
      gst_percent: "",
      gst_amount: "",
      containers: "",
    },
  ],
};


